import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  error: null,
  successResponse: null,      // For booking response
  bookingResponse: null,      // Also for clarity if needed
  rooms: [],                  // Room list
};

const RoomReducer = createSlice({
  name: "Room",
  initialState,
  reducers: {
    // ========== FETCH ROOMS ==========
    fetchRoomsRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchRoomsSuccess: (state, action) => {
      state.isLoading = false;
      state.rooms = action.payload;
    },
    fetchRoomsFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    // ========== BOOK ROOM ==========
    submitRoomRequest: (state) => {
      state.isLoading = true;
      state.error = null;
      state.successResponse = null;
    },
    submitRoomSuccess: (state, action) => {
      state.isLoading = false;
      state.successResponse = action.payload;
    },
    submitRoomFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    // ========== CLEAR STATE ==========
    clearRoomState: (state) => {
      state.isLoading = false;
      state.error = null;
      state.successResponse = null;
      state.bookingResponse = null;
    },
  },
});

export const {
  fetchRoomsRequest,
  fetchRoomsSuccess,
  fetchRoomsFailure,
  submitRoomRequest,
  submitRoomSuccess,
  submitRoomFailure,
  clearRoomState,
} = RoomReducer.actions;

export default RoomReducer.reducer;
